import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Hero from "../../components/hero/hero";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import About from "../../components/about/about";
import CtafromSection from "../../components/CtafromSection/CtafromSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Logo from "../../images/logo.svg";
import Ab1 from "../../images/about.webp";

const HomePage = () => {
  return (
    <Fragment>
      <Navbar hclass={"wpo-site-header"} Logo={Logo} />
      <Hero hclass={"static-hero"} />
      <ServiceSection
        hclass={"service_section section-padding"}
      />
      <About
        hclass={"about_section section-padding"}
        title="About SKIEN"
        subtitle="Enhancing Comfort, Care & Professional Excellence"
        image={Ab1}
        paragraphs={[
          "We understand the needs of professionals across beauty, wellness, and medical industries — from ensuring client comfort, to reducing practitioner fatigue, and creating efficient, safe environments. That's why we supply high-quality treatment beds, versatile chairs, ergonomic stools, and durable trolleys designed to support both practitioners and their clients.",
          "Our mission is to deliver reliable, long-lasting solutions that blend functionality with comfort. Whether in a salon, spa, or clinic, SKIEN products are crafted with premium materials and thoughtful design — helping professionals work smarter, and giving clients and patients the comfort and care they deserve.",
        ]}
      />
      <CtafromSection hclass={"ctafrom_section"} />
      <Footer hclass={"wpo-site-footer"} />
      <Scrollbar />
    </Fragment>
  );
};
export default HomePage;
